"use client";

import React from "react";
import { Dialog, DialogContent, DialogTrigger, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ZoomIn } from "lucide-react";
const galleryItems = [{
  id: 1,
  src: "https://dolcisaporisciacca.blueowlmedia.it/wp-content/uploads/2026/04/Torta-con-numeri-70-decorata-con-fragoline-e-panna_verticale.webp?v=xo06zo4pixo",
  alt: "Torta nuziale a piani con decorazioni floreali eleganti",
  title: "Torta Numero",
  category: "TORTA CON NUMERI 70 DECORATA CON FRAGOLINE E PANNA",
  description: "Torta per compleanno o anniversari",
  aspect: "aspect-[3/4]"
}, {
  id: 2,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/Torta-mimosa-mousse-limone-con-gele-alla-fragola.webp?v=4crdhjsswgs",
  alt: "Vassoio di cannoli siciliani freschi con ricotta e pistacchio",
  title: "Mousse Limone",
  category: "TORTA MIMOSA MOUSSE LIMONE CON GELE' ALLA FRAGOLA",
  description: "Torta mimosa mousse limone con gele' alla fragola",
  aspect: "aspect-[4/3]"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/cassata_siciliana_royal.png",
  alt: "Cassata siciliana tradizionale con frutta candita e glassa reale",
  title: "Cassata Reale",
  category: "Pasticceria Tradizionale",
  description: "Il dolce simbolo della Sicilia: pan di spagna, ricotta, pasta reale e preziosi frutti canditi per un'esplosione di gusto.",
  aspect: "aspect-square"
}, {
  id: 4,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/04/Torte-limone-dolci-sapori-sciacca_2.webp?v=i60jx2miq2",
  alt: "Torta di compleanno al cioccolato con drip cake e decorazioni",
  title: "Torte limone",
  category: "TORTE LIMONE\xA0",
  description: "Cassatine al limone",
  aspect: "aspect-[3/4]"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/almond_paste_cookies_assorted.png",
  alt: "Biscotti di pasta di mandorla siciliana assortiti",
  title: "Dolcezze di Mandorla",
  category: "Pasticceria Secca",
  description: "Morbidi pasticcini di pura mandorla siciliana, lavorati a mano uno ad uno secondo l'antica ricetta di famiglia.",
  aspect: "aspect-square"
}, {
  id: 6,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/04/Torta-fragoline-dolci-sapori-sciacca_2.webp?v=fgvlddnvz04",
  alt: "Torta moderna mousse al pistacchio e glassa a specchio",
  title: "Torta fragoline",
  category: "TORTA FRAGOLINE",
  description: "Torta di fragoline",
  aspect: "aspect-[4/5]"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/fresh_fruit_tart_cream.png",
  alt: "Crostata di frutta fresca con crema pasticcera",
  title: "Giardino di Frutta",
  category: "Pasticceria Fresca",
  description: "Frolla friabile, vellutata crema pasticcera e una selezione della migliore frutta fresca di stagione.",
  aspect: "aspect-[4/3]"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562811/img/ricotta_pastry_sfogliatella.png",
  alt: "Sfogliatelle e dolci alla ricotta appena sfornati",
  title: "Risveglio Croccante",
  category: "Colazione",
  description: "La fragranza della sfoglia appena sfornata incontra il cuore morbido della ricotta dolce.",
  aspect: "aspect-[3/4]"
}];
export default function LArteInPasticceria() {
  return <section id="larte-in-pasticceria" className="bg-background text-foreground ![padding:48px_0px_0px_0px]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-primary">
            L'Arte in Pasticceria
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">
            Un viaggio visivo tra le nostre creazioni artigianali. Dalle torte nuziali personalizzate ai grandi classici della tradizione siciliana, ogni dolce racconta una storia di passione e qualità.
          </p>
        </div>

        
      </div>
    </section>;
}